import { RebateModalContentInterface } from '../../../../types';
import MatchingRebateCard from './MatchingRebateCard';
import RebatesModalButtons from './RebatesModalButtons';

const RebatesModalContent = ({
  rebates,
  rebateIcon,
  closeRebateModal,
  primaryButtonText,
  secondaryButtonText,
}: RebateModalContentInterface) => {
  return (
    <>
      {rebates[0] && (
        <>
          {/* reproducing current state where only one rebate is shown even if multiple rebates are present for the selected jurisdiction */}
          <MatchingRebateCard
            icon={rebateIcon}
            rebateTitle={rebates[0].title}
            rebateDescription={rebates[0].description}
          />
          <RebatesModalButtons
            offerLearnMore={rebates[0].learnMore}
            closeRebateModal={closeRebateModal}
            primaryButtonText={primaryButtonText}
            secondaryButtonText={secondaryButtonText}
          />
        </>
      )}
    </>
  );
};

export default RebatesModalContent;
